import { cx } from "@/lib/cx";
import { useCurrentActor } from "@/lib/current-actor";

/**
 * DESIGN.md's exact sentence for a Read-only user, `{typography.meta}`, and
 * nothing else — no permission-denied screen exists anywhere (VC-2.1-15).
 *
 * Rendered by each caller inside its own content column (currently
 * `DestinationPlaceholder`, above the title) rather than floating in the
 * shell chrome — `className` lets the caller set the spacing that fits its
 * own layout. `useCurrentActor` is the only source consulted (VC-2.1-17);
 * there is no separate Read-only flag anywhere else that could disagree
 * with it.
 */
export function ReadOnlyNotice({ className }: { className?: string }) {
  const { data: actor } = useCurrentActor();

  if (actor?.role !== "read_only") {
    return null;
  }

  return <p className={cx("text-meta text-ink-secondary", className)}>You have view-only access.</p>;
}
